import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationOffersHubScreens,
  simulationPrivatePayrollScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado privado no caminho do legado com o rótulo padrão (`router.tsx:1145-1155`, só com
// `ENABLE_NEW_SIMULATION === 1`): a flag e a permissão vão no manifesto. Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/ccb/contratar/consignado-privado/')({
  staticData: { screen: simulationPrivatePayrollScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationOffersHubScreens, 'PrivatePayrollHubRouteScreen'),
});
